<template>
  <div class="pause">
    <button @click="chooseResponse" fill>{{ message.options.label }}</button>
  </div>
</template>

<script>
import { Message } from '@/bot-engine.es5.js';

export default {
  props: {
    message: {
      type: Message
    }
  },
  methods: {
    chooseResponse() {
      this.$emit("selected", {id: "", label: this.message.options.label });
    }
  }
}
</script>

<style scoped>
@keyframes fromright {
  0%   {left:200%; top:0px;}
  75%  {left:10%; top:0px;}
  100% {left:0px; top:0px;}
}

  .pause {
    animation-name: fromright;
    animation-duration: 1s;
    animation-timing-function: ease-in-out;
    position: relative;
  }
</style>
